import { SET_TRUCK_ATTRIBUTE } from 'vx/mutations'
import { find, isObject } from 'lodash'

export default {
  computed: {
    user: {
      get () {
        return this.truck.user_id
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'user_id', value })
      }
    },

    location: {
      get () {
        return this.truck.location_id
      },

      set (value) {
        let location = isObject(value) ? value : (find(this.locations, location => location.id === value) || null)
        let id = isObject(location) ? location.id : null

        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'location', value: location })
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'location_id', value: id })
      }
    },

    driver: {
      get () {
        return this.truck.driver_id
      },

      set (value) {
        let driver = isObject(value) ? value : (find(this.drivers, driver => driver.id === value) || null)
        let id = isObject(driver) ? driver.id : null

        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'driver', value: driver })
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'driver_id', value: id })
      }
    },

    registration: {
      get () {
        return this.truck.registration
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'registration', value })
      }
    },

    make: {
      get () {
        return this.truck.make
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'make', value })
      }
    },

    model: {
      get () {
        return this.truck.model
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'model', value })
      }
    },

    year: {
      get () {
        return this.truck.year
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'year', value })
      }
    },

    yearExpiry: {
      get () {
        return this.truck.year_expiry
      },

      set (value) {
        this[SET_TRUCK_ATTRIBUTE]({ attribute: 'year_expiry', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/trucks/state-mapper.js